import React from 'react'
import Formsy from 'formsy-react';
import {Input} from '../form';

class FormSubmitTester extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      ajaxFormModel: {}
    }
  }

  render() {

    const { showErrors, ajaxFormModel } = this.state;

    return (
      <div className="FormSubmitTester">
        <h1>Form Submission Tests:</h1>
        <h3>Ajax Form</h3>
        <div className="s3">
          <Formsy onValidSubmit={(model) => this.onValidSubmit(model) } className="ajax-form">
            <Input name="emailtest"
                   type="email"
                   icon="envelope"
                   label="Email"
                   showErrors={showErrors}
                   validations="isEmail"
                   validationError="This is not a valid email"
                   inputSize="pt-large"
                   required />
            <Input name="passwordtest"
                   showErrors={showErrors}
                   icon="key"
                   label="Password"
                   type="password"
                   inputSize="pt-large"
                   required />
            <button type="submit" className="pt-button pt-large pt-icon-log-in pt-intent-primary">Submit</button>
          </Formsy>
        </div>
        <div className="s3">
          <div>
            Email submitted: <b className="emailtest">{ajaxFormModel.emailtest}</b>
          </div>
          <div>
            Password: <b className="passwordtest">{ajaxFormModel.passwordtest}</b>
          </div>
        </div>
        <h3>Regular old form</h3>
        <form action="/test-playground/formsubmission-success" method="get">
          <div className="pt-form-group">
            <label className="pt-label" htmlFor="example-form-group-input-b">
              Email:
            </label>
            <div className="pt-form-content">
              <div className="pt-input-group">
                <input id="example-form-group-input-b" className="pt-input" type="email" dir="auto" />
              </div>
            </div>
          </div>
          <div className="pt-form-group">
            <label className="pt-label" htmlFor="example-form-group-input-b">
              Password:
            </label>
            <div className="pt-form-content">
              <div className="pt-input-group">
                <input id="example-form-group-input-b" className="pt-input" type="password" dir="auto" />
              </div>
            </div>
          </div>
          <button className="pt-button pt-large pt-icon-log-in pt-intent-primary">Submit</button>
        </form>
      </div>
    )
  }

  onValidSubmit(model) {
    this.setState({ ajaxFormModel: model })
  }

}

export default FormSubmitTester;



// WEBPACK FOOTER //
// ./src/components/testplayground/FormSubmitTester.js